/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AppIcon = ({ width = 24, height = 24, hidden = false, title = 'App' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M13.25,18h-6.5c-2.61914,0-4.75-2.13086-4.75-4.75v-6.5c0-2.61914,2.13086-4.75,4.75-4.75h6.5c2.61914,0,4.75,2.13086,4.75,4.75v6.5c0,2.61914-2.13086,4.75-4.75,4.75ZM6.75,3.5c-1.79199,0-3.25,1.45801-3.25,3.25v6.5c0,1.79199,1.45801,3.25,3.25,3.25h6.5c1.79199,0,3.25-1.45801,3.25-3.25v-6.5c0-1.79199-1.45801-3.25-3.25-3.25h-6.5Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M13.44043,12.72461l-2.75-6.5c-.23438-.55469-1.14648-.55469-1.38086,0l-2.75,6.5c-.16211.38086.0166.82129.39844.98242.37891.16602.82129-.0166.98242-.39844l.76538-1.80859h2.58838l.76538,1.80859c.12109.28613.39844.45801.69043.45801.09766,0,.19727-.01855.29199-.05957.38184-.16113.56055-.60156.39844-.98242ZM9.34033,10l.65967-1.55859.65967,1.55859h-1.31934Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
